import Backbone from '@polleverywhere/backbone'
import { compareInt } from '@polleverywhere/core/lib/util'
import DiscourseResult from './result'

const STRATEGIES = {
  recent (result) { return -result.id },
  mine (result) { return -result.get('score') },
  top (result1, result2) {
    // sort results descending when scores are identical
    if (result1.get('score') === result2.get('score')) {
      if (result1.id > result2.id) {
        return 1
      } else {
        return -1
      }
    } else {
      if (result1.get('score') > result2.get('score')) {
        return -1
      } else {
        return 1
      }
    }
  },
  netVotes (result1, result2) {
    // Compare by net votes first
    let comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'))

    if (comparison !== 0) { return comparison }

    // Use upvotes as a tie breaker
    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'))
    if (comparison !== 0) {
      return comparison
    } else {
      // Use chronological order as the 2nd tie breaker
      return compareInt(result2.id, result1.id)
    }
  },
  netVotesRecentFirst (result1, result2) {
    // Compare by net votes first
    let comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'))

    if (comparison !== 0) { return comparison }

    // Use upvotes as a tie breaker
    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'))
    if (comparison !== 0) {
      return comparison
    } else {
      // Use reverse chronological order as the 2nd tie breaker
      return compareInt(result1.id, result2.id)
    }
  }
}

// @namespace Model
export default class DiscourseResults extends Backbone.Collection {
  get model () { return DiscourseResult }

  get sortStrategy () { return 'recent' }

  get strategies () { return STRATEGIES }

  comparator (result) {
    return result.id ? -result.id : -Infinity
  }

  /**
   * @param {Array} models Array of result models or datasets to initially add.
   * @param {Object} options
   * @param {Poll} options.poll Activity model this collection belongs to.
   * @param {string} options.source Metadata about where results come from.
   */
  initialize (models, options = {}) {
    /**
     * TODO(shared): Rename this property to `activity` and update all consuming
     * repos to stop using `poll` because results are associated to both polls
     * and surveys. The word poll is misleading.
     *
     * Holds reference to the parent activity associated with these results.
     * Can be poll or MQA models (e.g. survey).
     * @type {Backbone.Model}
     */
    this.poll = options.poll

    /**
     * Metadata to send when saving batch results as a single request. See docs:
     * https://ci.ops.pe/browse/RA-REDOC/latest/artifact/JOB1/Site/ci.html#tag/Participant::BatchResults
     * @type {string}
     */
    this.source = options.source
  }

  fetch () {
    console.log('DiscourseResults#fetch : not implemented')
  }

  changeSort (strategy) {
    this.comparator = this.strategies[strategy]
  }

  maxUpvotes () {
    return Math.max.apply(Math, this.pluck('upvotes').concat(0))
  }

  maxDownvotes () {
    return Math.max.apply(Math, this.pluck('downvotes').concat(0))
  }
}
